import styled from "styled-components/macro";
import Button from "../Buttons";
import { media } from "../../../utils";

const getButtonActiveStyle = (buttonActive) =>
  buttonActive
    ? `
    left: 0%;
    transition: left 0.5s;
`
    : `
    left: 50%;
    transition: left 0.5s;
    `;

export const ButtonsContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.neutral["05"]};
  border-radius: 500px;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 25px;
  position: relative;
`;

export const ToggleButton = styled.div`
  display: ${({ buttonActive }) => (buttonActive === "" ? "none" : "block")};
  background-color: ${({ theme }) => theme.color.brandPrimary.light};
  position: absolute;
  top: 0;
  border-radius: 500px;
  width: 50%;
  height: 100%;
  text-align: center;
  padding-top: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.color.neutral["08"]};
  ${({ isLeft }) => getButtonActiveStyle(isLeft)}

  ${media.md()} {
    padding-top: 12px;
  }
`;

export const SwitchButton = styled(Button)`
  border: none;
  background-color: ${({ theme }) => theme.color.line.light};
  color: ${({ theme }) => theme.color.brandPrimary.light};
  margin: 0;
  padding: 12px 12px;
  width: 50%;
  ${media.md()} {
    padding: 12px 36px;
  }

  &:hover:not(:disabled) {
    box-shadow: none;
  }
`;

export const SwitchContent = styled.div(() => ({
  display: "none",
  "&.active": {
    display: "block",
  },
}));

export const SwitchContainer = styled.div(() => ({
  [media.lg()]: {
    "&.disabled-lg": {
      "& > .Card__Header": {
        display: "none",
      },
      [`${SwitchContent}`]: {
        display: "block",
      },
    },
  },
}));
